module.exports = __webpack_public_path__ + "img/phoenix.195b464e.png";